import { render, staticRenderFns } from "./RolePermissionDetails.vue?vue&type=template&id=6977e560"
import script from "./RolePermissionDetails.vue?vue&type=script&lang=js"
export * from "./RolePermissionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports